module.exports = __webpack_public_path__ + "img/extern.cb674f9d.png";